/* 23.05.30 수정: useRef 추가  */
import React, { useEffect, useRef, useState } from "react";
import cn from "classnames/bind";
import lottie from "lottie-web";

import lottieWonders1 from "../assets/video/lottie_wonders1.json";
import lottieWonders2 from "../assets/video/lottie_wonders2.json";

const LottieComponent = () => {
  const lottieRef = useRef(null);
  const [secondLottieShow, setSecondLottieShow] = useState(false);

  useEffect(() => {
    let lottieLoad = lottie.loadAnimation({
      container: lottieRef.current,
      renderer: "svg",
      loop: false,
      autoplay: true,
      animationData: lottieWonders1,
      rendererSettings: {
        className: "first-lottie",
      },
    });

    lottieLoad.onComplete = () => {
      setSecondLottieShow(true);
      lottieLoad = lottie.loadAnimation({
        container: lottieRef.current,
        renderer: "svg",
        loop: true,
        autoplay: true,
        animationData: lottieWonders2,
      });
    };
    return () => lottieLoad.destroy();
  }, []);

  return (
    <div
      className={cn(
        "visual inner-column",
        secondLottieShow && "second-lottie-show",
      )}
    >
      <div className={cn("lottie-wrap")} ref={lottieRef}></div>
    </div>
  );
};

export default LottieComponent;
